import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["backgroundColor", "color", "loadingStyle", "spinnerSize", "supportingText", "supportingTextColor", "value", "variant"];
import React from 'react';
import CircularProgress, { circularProgressClasses } from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/system';
// import { LoadingDotCircle } from './LoadingDotCircle';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var sizeMap = {
  lg: 56,
  md: 48,
  sm: 32,
  xl: 64
};
var getGap = function getGap(size, controlledSize) {
  if (typeof controlledSize === 'number') {
    return size > sizeMap['xl'] ? '20px' : '16px';
  }
  return controlledSize === 'xl' ? '20px' : '16px';
};
var getValue = function getValue(val) {
  if (!val) return 0;
  if (val > 100) return 100;
  return val;
};
export function LoadingIndicator(props) {
  var backgroundColor = props.backgroundColor,
    _color = props.color,
    loadingStyle = props.loadingStyle,
    controlledSize = props.spinnerSize,
    supportingText = props.supportingText,
    supportingTextColor = props.supportingTextColor,
    value = props.value,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
    others = _objectWithoutProperties(props, _excluded);

  // if (loadingStyle === 'dot-circle') {
  //   return (
  //     <Box sx={{ position: 'relative' }}>
  //       <LoadingDotCircle size={controlledSize} />
  //       {loadingText}
  //     </Box>
  //   );
  // }
  var theme = useTheme();
  var size = typeof controlledSize === 'number' ? controlledSize : sizeMap[controlledSize != null ? controlledSize : 'md'];
  var baseColor = backgroundColor ? backgroundColor : theme.palette.gray[100];
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'grid',
      gap: getGap(size, controlledSize),
      justifyItems: 'center',
      overflow: 'hidden',
      position: 'relative'
    },
    "data-element": "Box",
    "data-component": "LoadingIndicator",
    "data-source-file": "LoadingIndicator.tsx",
    children: [/*#__PURE__*/_jsx(CircularProgress, _extends({
      size: size,
      sx: {
        color: loadingStyle === 'line-simple' ? 'transparent' : baseColor,
        margin: 0
      },
      thickness: controlledSize === 'md' || controlledSize === 'sm' ? 4 : 5
    }, others, {
      value: 100,
      variant: "determinate",
      "data-element": "CircularProgress",
      "data-source-file": "LoadingIndicator.tsx"
    })), /*#__PURE__*/_jsx(CircularProgress, _extends({
      disableShrink: true,
      size: size,
      sx: _defineProperty({
        animationDuration: '1000ms',
        color: function color(theme) {
          return _color ? _color : theme.palette.primary[600];
        },
        margin: 0,
        position: 'absolute'
      }, "& .".concat(circularProgressClasses.circle), {
        strokeLinecap: 'round'
      }),
      thickness: controlledSize === 'md' || controlledSize === 'sm' ? 4 : 5,
      value: getValue(value),
      variant: variant
    }, others, {
      "data-element": "CircularProgress",
      "data-source-file": "LoadingIndicator.tsx"
    })), supportingText && /*#__PURE__*/_jsx(Typography, {
      align: "center",
      flexWrap: "wrap",
      sx: {
        color: function color(theme) {
          return supportingTextColor ? supportingTextColor : theme.palette.gray[700];
        },
        wordBreak: 'break-word'
      },
      variant: size < sizeMap['md'] ? 'text-sm-medium' : 'text-lg-medium',
      children: supportingText
    })]
  });
}